import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginResult } from '../models/login-result.model';
import { ChangePasswordRequest, ForgotPasswordResponse } from '../models/forgot-password-response.model';
import { ChangePasswordResponse } from '../models/change-password-response.model';
import { GetRefreshTokenResponse } from '@/core/models/get-refreshToken-response.model';
import { Observable } from 'rxjs';
import { BaseResponseModel } from '@/core/models/baseModel';

@Injectable({
    providedIn: 'root'
})
export class AuthApi {
    http = inject(HttpClient);
    private baseUrl = `${environment.apiUrl}`;
    header = { 'Content-Type': 'application/json' };

    login(email: string, password: string) {
        return this.http.post<LoginResult>(`${this.baseUrl}/auth/login-for-mobile`, { Email: email, Password: password }, { headers: this.header });
    }

    forgotPassword(Email: string) {
        return this.http.post<ForgotPasswordResponse>(`${this.baseUrl}/auth/forgot-password`, { Email }, { headers: this.header });
    }

    // changePassword(Email: string, OldPassword: string, NewPassword: string, ConfirmPassword: string) {
    //     return this.http.post<ChangePasswordResponse>(`${this.baseUrl}/employee/change-password`, { Email, OldPassword, NewPassword, ConfirmPassword }, { headers: this.header });
    // }
    // changePassword(email: string, oldPassword: string, newPassword: string, confirmPassword: string): Observable<BaseResponseModel> {
    //     return this.http.post<BaseResponseModel>(
    //         `${this.baseUrl}/employee/change-password`,
    //         { Email: email, OldPassword: oldPassword, NewPassword: newPassword, ConfirmPassword: confirmPassword },
    //         { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    //     );
    // }
    changePassword(payload: ChangePasswordRequest): Observable<BaseResponseModel> {        
        return this.http.post<BaseResponseModel>(
            `${this.baseUrl}/auth/change-password`,
            payload,
            { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
        );
    }

    getRefreshToken(refreshToken: string) {
        return this.http.post<GetRefreshTokenResponse>(`${this.baseUrl}/refresh`, { refreshToken }, { headers: this.header });
    }
}
